<script>
import { mapState, mapActions } from "vuex";
import EncuestaModalExito from "@/components/intranet/encuesta/EncuestaModalExito.vue";
import IconEncuestas from "@/assets/img/icon/section/IconEncuestas.vue";

export default {
  name: "EncuestaSingle",
  components: {
    EncuestaModalExito,
    IconEncuestas,
  },
  data() {
    return {
      preguntas: null,
      preguntaActive: 0,
      count: {},
      respuestas: [],
      respuesta_desarrollo: null,
      respuesta_multiple_simple: null,
      respuesta_multiple: [],
      respuesta_start: null,
      respuesta_lineal: null,
      respuesta_emoji: null,

      //FF
      active: 0,
      rango_estrellas: 0,
    };
  },
  computed: {
    ...mapState("EncuestaModule", ["encuestaIdAdmin"]),
  },
  created() {
    this.getEncuesta();
  },
  methods: {
    ...mapActions("EncuestaModule", ["getEncuestaId", "responderEncuesta"]),

    async getEncuesta() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_encuesta: this.$route.params.id_encuesta,
      };
      await this.getEncuestaId(data_).then((encuesta) => {
        //console.log("rev: ", encuesta);
        if (encuesta) {
          this.preguntas = encuesta.preguntas;
          this.preguntas.forEach((element) => {
            this.respuestas.push({
              id_pregunta: element.id_pregunta,
              respuesta: null,
            });
          });
        }
      });
    },

    charCount(e) {
      e.target.nextElementSibling.innerHTML = `${e.target.value.length}/1500`;
    },

    seleccionRespuestas(tipo_encuesta, index_respuestas) {
      if (tipo_encuesta == 3 || tipo_encuesta == 7) {
        let respuesta_ajustada = null;
        if (this.respuesta_multiple.length > 0) {
          respuesta_ajustada = this.respuesta_multiple.join();
        }
        this.respuestas[index_respuestas].respuesta = respuesta_ajustada;
      }
    },

    async handleSubmit() {
      let data_ = {
        respuestas: this.respuestas,
        id_encuesta: this.$route.params.id_encuesta,
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
      };
      await this.responderEncuesta(data_).then((encuesta) => {
        if (encuesta) {
          document.getElementById("btn-modal-exito").click();
        }
      });
      
    },

    //FF
    cambiarPregunta(pregunta, now) {
      this.active = parseInt(pregunta);
      let id_pregunta = this.preguntas[pregunta].id_pregunta;
      let objeto_respuesta = this.respuestas.find(
        (respuesta) => respuesta.id_pregunta == id_pregunta
      );
      if (pregunta > now && objeto_respuesta.respuesta == null) {
        this.respuesta_multiple = [];
      } else if (pregunta < now || objeto_respuesta.respuesta != null) {
        if (objeto_respuesta != null) {
          let objeto_procesado = objeto_respuesta.respuesta.split(",");
          this.respuesta_multiple = [];
          objeto_procesado.forEach((element) => {
            this.respuesta_multiple.push(element);
          });
        }
      }
    },
    rangeStar(star) {
      this.rango_estrellas = star;
    },
  },
};
</script>

<template>
  <section id="encuesta">
    <div class="row">
      <div class="col-12 mb-0">
        <h1
          class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center"
        >
          <IconEncuestas class="me-2 icon-svg-45" />
          {{ encuestaIdAdmin.nombre_encuesta }}
        </h1>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/encuesta">
                <font-awesome-icon
                  icon="fa-solid fa-square-check"
                ></font-awesome-icon>
                Encuestas
              </router-link>
            </li>
            <li class="breadcrumb-item active">
              {{ encuestaIdAdmin.nombre_encuesta }}
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-12 mb-3 mb-lg-0">
        <p class="text-secondary h5-custom mb-0">
          Danos tu opinión, se parte de procesos corporativos y responde
          dinámicas encuestas para mejor nuestro clima.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div>
    <div class="row" v-if="encuestaIdAdmin">
      <div class="col-12">
        <div
          v-if="encuestaIdAdmin && preguntas && respuestas"
          class="card border-0"
        >
          <div class="card-body">
            <div
              v-for="(pregunta, index) in preguntas"
              :key="index"
              class="row"
            >
              <div
                class="col-12"
                :class="
                  active === index ? 'd-flex flex-column c-form-contasine' : ''
                "
              >
                <div
                  class="row d-flex justify-content-center flex-grow-1 over-y"
                >
                  <div v-if="active === index" class="col-12 col-xl-7 my-3">
                    <div class="row">
                      <div
                        class="col-12 d-flex align-items-center justify-content-between"
                      >
                        <h6 class="font-700 font-main text-secondary mb-0">
                          {{ pregunta.texto_pregunta }}
                        </h6>

                        <div
                          class="d-flex align-items-center rounded-pill py-2 px-3 card-shadow text-secondary"
                        >
                          <a
                            href="javascript:"
                            class="h4 link-secondary mb-0 me-3"
                            :class="index === 0 ? 'disabled-click' : ''"
                            @click="cambiarPregunta(index - 1, index)"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-angle-left"
                            ></font-awesome-icon>
                          </a>
                          <span class="d-flex me-1">
                            {{ index + 1 }}
                          </span>
                          de
                          <span class="d-flex ms-1">
                            {{ preguntas.length }}
                          </span>
                          <a
                            href="javascript:"
                            class="h4 link-secondary mb-0 ms-3"
                            :class="
                              index === preguntas.length - 1 ||
                              respuestas[index].respuesta == null
                                ? 'disabled-click'
                                : ''
                            "
                            @click="cambiarPregunta(index + 1, index)"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-angle-right"
                            ></font-awesome-icon>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="border-bottom mb-4 pb-4"></div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <!-- Desarrollo -->
                        <template
                          v-if="pregunta.tipo_pregunta.id_pregunta_tipo == 1"
                        >
                          <textarea
                            class="textarea-auto textarea-250"
                            rows="3"
                            maxlength="1500"
                            @keyup="charCount"
                            placeholder="Escribe una respuesta..."
                            v-model="respuestas[index].respuesta"
                          ></textarea>
                          <div class="form-text text-end text-secondary">
                            0/1500
                          </div>
                          <!-- @input="seleccionRespuestas(pregunta.tipo_pregunta.id_pregunta_tipo, index, respuesta_desarrollo)" -->
                        </template>
                        <!-- Seleccion unica -->
                        <template
                          v-if="pregunta.tipo_pregunta.id_pregunta_tipo == 2"
                        >
                          <ul class="list-group list-group-flush">
                            <li
                              v-for="alternativa in pregunta.alternativas"
                              :key="alternativa.id_alternativa"
                              class="list-group-item d-flex justify-content-between align-items-center px-0"
                            >
                              <label
                                class="flex-grow-1 form-check-label text-secondary pointer-event"
                                :for="`alternativas-pregunta-${alternativa.id_alternativa}`"
                              >
                                {{ alternativa.texto_alternativa }}
                              </label>
                              <input
                                class="form-check-input input-radio-custom me-1"
                                type="radio"
                                :id="`alternativas-pregunta-${alternativa.id_alternativa}`"
                                :name="`alternativas-pregunta-${index}`"
                                :value="alternativa.texto_alternativa"
                                v-model="respuestas[index].respuesta"
                              />
                              <!-- @change="seleccionRespuestas(pregunta.tipo_pregunta.id_pregunta_tipo ,index, alternativa.texto_alternativa)" -->
                            </li>
                          </ul>
                        </template>
                        <!-- Seleccion multiple -->
                        <template
                          v-if="pregunta.tipo_pregunta.id_pregunta_tipo == 3"
                        >
                          <ul class="list-group list-group-flush">
                            <li
                              v-for="alternativa in pregunta.alternativas"
                              :key="alternativa.id_alternativa"
                              class="list-group-item d-flex justify-content-between align-items-center px-0"
                            >
                              <label
                                class="flex-grow-1 form-check-label text-secondary pointer-event"
                                :for="`alternativas-pregunta-${alternativa.id_alternativa}`"
                              >
                                {{ alternativa.texto_alternativa }}
                              </label>
                              <input
                                class="form-check-input input-checkbox-custom me-1"
                                type="checkbox"
                                :id="`alternativas-pregunta-${alternativa.id_alternativa}`"
                                :name="`alternativas-pregunta-${index}`"
                                :value="alternativa.texto_alternativa"
                                v-model="respuesta_multiple"
                                @change="
                                  seleccionRespuestas(
                                    pregunta.tipo_pregunta.id_pregunta_tipo,
                                    index
                                  )
                                "
                              />
                            </li>
                          </ul>
                        </template>
                        <!-- Calificación -->
                        <template
                          v-if="pregunta.tipo_pregunta.id_pregunta_tipo == 4"
                        >
                          <template v-if="pregunta.is_star">
                            <div class="d-flex justify-content-center">
                              <div
                                class="card d-inline-flex border-0 card-shadow rounded-pill"
                              >
                                <div class="card-body">
                                  <label
                                    v-for="alternativa in pregunta.alternativas"
                                    :key="alternativa.id_alternativa"
                                    @click="
                                      rangeStar(alternativa.texto_alternativa)
                                    "
                                    class="d-inline-flex my-2 mx-3 pointer-event"
                                    :class="
                                      alternativa.texto_alternativa <=
                                      rango_estrellas
                                        ? 'link-warning'
                                        : 'link-secondary opacity-25'
                                    "
                                  >
                                    <font-awesome-icon
                                      icon="fa-solid fa-star"
                                      class="h1 mb-0"
                                    ></font-awesome-icon>
                                    <input
                                      class="d-none"
                                      type="radio"
                                      :name="`alternativas-pregunta-${index}`"
                                      :value="alternativa.texto_alternativa"
                                      v-model="respuestas[index].respuesta"
                                    />
                                  </label>
                                  <!-- @change="seleccionRespuestas(index, alternativa.texto_alternativa)" -->
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-if="!pregunta.is_star">
                            <div class="row">
                              <div
                                class="col text-center"
                                v-for="alternativa in pregunta.alternativas"
                                :key="alternativa.id_alternativa"
                              >
                                <label class="text-secondary d-block">
                                  {{ alternativa.texto_alternativa }}
                                </label>
                                <input
                                  class="form-check-input input-radio-custom"
                                  type="radio"
                                  :name="`alternativas-pregunta-${index}`"
                                  :value="alternativa.texto_alternativa"
                                  v-model="respuestas[index].respuesta"
                                />
                              </div>
                            </div>
                            <!-- @change="seleccionRespuestas(index, alternativa.texto_alternativa)" -->
                          </template>
                        </template>
                        <!-- Emoticones -->
                        <template
                          v-if="pregunta.tipo_pregunta.id_pregunta_tipo == 5"
                        >
                          <div class="row d-flex justify-content-center">
                            <div
                              class="col-4 col-lg-2 col-xl-3 text-center"
                              v-for="alternativa in pregunta.alternativas"
                              :key="alternativa.id_alternativa"
                            >
                              <img
                                :src="alternativa.texto_alternativa"
                                class="img-fluid"
                                alt="Insatisfecho"
                              />
                              <input
                                class="form-check-input input-radio-custom"
                                type="radio"
                                :name="`alternativas-pregunta-${index}`"
                                :value="alternativa.texto_alternativa"
                                v-model="respuestas[index].respuesta"
                              />
                            </div>
                            <!-- @change="seleccionRespuestas(index, alternativa.texto_alternativa)" -->
                          </div>
                        </template>
                        <!-- Multimedia single -->
                        <template
                          v-if="pregunta.tipo_pregunta.id_pregunta_tipo == 6"
                        >
                          <div class="row d-flex justify-content-center">
                            <template v-if="alternativa.texto_alternativa">
                              <div
                                class="col-4 col-lg-2 col-xl-3 text-center gap-3"
                                v-for="alternativa in pregunta.alternativas"
                                :key="alternativa.id_alternativa"
                              >
                                <label
                                  :for="`alternativas-pregunta-${alternativa.id_alternativa}`"
                                >
                                  <video
                                    controls
                                    class="img-fluid"
                                    v-if="
                                      alternativa.texto_alternativa.includes(
                                        '.mp4'
                                      )
                                    "
                                    :src="alternativa.texto_alternativa"
                                  ></video>
                                  <img
                                    class="img-fluid"
                                    v-else
                                    :src="alternativa.texto_alternativa"
                                  />
                                </label>
                                <input
                                  class="form-check-input input-radio-custom"
                                  type="radio"
                                  :id="`alternativas-pregunta-${alternativa.id_alternativa}`"
                                  :name="`alternativas-pregunta-${index}`"
                                  :value="alternativa.texto_alternativa"
                                  v-model="respuestas[index].respuesta"
                                />
                              </div>
                            </template>
                          </div>
                        </template>
                        <!-- Multimedia multiple -->
                        <template
                          v-if="pregunta.tipo_pregunta.id_pregunta_tipo == 7"
                        >
                          <table class="list-ckecks">
                            <tbody>
                              <tr
                                v-for="alternativa in pregunta.alternativas"
                                :key="alternativa.id_alternativa"
                                class="list-ckecks__row"
                              >
                                <template v-if="alternativa.texto_alternativa">
                                  <td class="list-ckecks__col">
                                    <label
                                      class="form-check-label text-secondary pointer-event d-flex justify-content-left  px-4"
                                      :for="`alternativas-pregunta-${alternativa.id_alternativa}`"
                                    >
                                      <video
                                        controls
                                        class="img-fluid my-1"
                                        v-if="
                                          alternativa.texto_alternativa.includes(
                                            '.mp4'
                                          )
                                        "
                                        :src="alternativa.texto_alternativa"
                                      ></video>
                                      <img
                                        class="img-fluid my-1"
                                        v-else
                                        :src="alternativa.texto_alternativa"
                                      />
                                    </label>
                                  </td>
                                  <td class="list-ckecks__col">
                                    <div
                                      class="d-flex justify-content-center px-4"
                                    >
                                      <input
                                        class="form-check-input input-checkbox-custom me-1"
                                        type="checkbox"
                                        :id="`alternativas-pregunta-${alternativa.id_alternativa}`"
                                        :name="`alternativas-pregunta-${index}`"
                                        :value="alternativa.texto_alternativa"
                                        v-model="respuesta_multiple"
                                        @change="
                                          seleccionRespuestas(
                                            pregunta.tipo_pregunta
                                              .id_pregunta_tipo,
                                            index
                                          )
                                        "
                                      />
                                    </div>
                                  </td>
                                </template>
                              </tr>
                            </tbody>
                          </table>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="active === index" class="row">
                  <div class="col-12 d-flex justify-content-end">
                    <button
                      v-if="active !== preguntas.length - 1"
                      class="btn btn-custom btn-custom-main rounded-pill mw-150"
                      :disabled="respuestas[active].respuesta == null"
                      @click="cambiarPregunta(active + 1, index)"
                    >
                      Siguiente
                    </button>
                    <button
                      v-else
                      class="btn btn-custom btn-custom-main rounded-pill mw-150"
                      :disabled="respuestas[index].respuesta == null"
                      @click="handleSubmit()"
                    >
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <EncuestaModalExito />

    <button
      id="btn-modal-exito"
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modal-exito"
    ></button>
  </section>
</template>
